import React, { useEffect, useState } from 'react';
import { formatElapsedDuration } from '../utils/elapsedTime';

/** Live elapsed-time label; pass startedAt as ms since epoch when the job began. */
export default function ElapsedTimer({ startedAt, className = '' }) {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);

  useEffect(() => {
    if (!startedAt) {
      setElapsedSeconds(0);
      return undefined;
    }
    const tick = () => {
      setElapsedSeconds(Math.floor((Date.now() - startedAt) / 1000));
    };
    tick();
    const intervalId = setInterval(tick, 1000);
    return () => clearInterval(intervalId);
  }, [startedAt]);

  if (!startedAt) {
    return null;
  }

  return (
    <span
      className={`text-xs tabular-nums text-gray-400 ${className}`.trim()}
      aria-label={`Elapsed time ${formatElapsedDuration(elapsedSeconds)}`}
    >
      {formatElapsedDuration(elapsedSeconds)}
    </span>
  );
}
